import React, { useState } from 'react';
import './ShoppingCartSummary.css';
import './shopping-cart.jpg';
import { useNavigate } from 'react-router-dom';
import { FaShoppingCart } from "react-icons/fa";

function ShoppingCartSummary({cart, setCart, total, setTotal}) {
  const [page] = useState("afrekenen");
  const navigate = useNavigate();
    const [gekozenLevering, setGekozenLevering] = useState('leveren');
    const [toonError, setToonError] = useState(false);

  const addItem = (item) => {
    const existingItem = cart.find((cartItem) => cartItem.id === item.id);
    if (existingItem) {
      setCart(
        cart.map((cartItem) =>
          cartItem.id === item.id
            ? { ...cartItem, quantity: cartItem.quantity + 1 }
            : cartItem
        )
      );
    } else {
      setCart([...cart, { ...item, quantity: 1 }]);
    }
    setTotal(total + item.price);
  };

  const handleChange = (event) => {
    setGekozenLevering(event.target.value);
  };

  const removeItem = (item) => {
    const existingItem = cart.find((cartItem) => cartItem.id === item.id);
    if (existingItem.quantity === 1) {
      setCart(cart.filter((cartItem) => cartItem.id !== item.id));
    } else {
      setCart(
        cart.map((cartItem) =>
          cartItem.id === item.id
            ? { ...cartItem, quantity: cartItem.quantity - 1 }
            : cartItem
        )
      );
    }
    setTotal(total - item.price);
  };

  const winkelwagenLeegmaken = () => {
    setCart([]);
    setTotal(0);
  }
  
  const afrekenen = () => {
    if (total > 0) {
    navigate('/winkelwagen', {state: {
      total,
      cart
    }});
    } else {
      setToonError(true);
    }
  }

  return (
       <div title="Cart" className="cart_icon">
          <img onClick={() => afrekenen()} src={require('./shopping-cart.jpg')} />
          <span className="badge">{cart.length > 0 ? cart[0].quantity :  0}</span>
          <span>€{total},00</span>
          {total > 0 ? <button id="winkelwagen-btn" onClick={() => winkelwagenLeegmaken()}>Winkelwagen leegmaken</button>:null}
          {total > 0 ? <button onClick={() => afrekenen()}>Afrekenen</button>: null}
          {toonError?<div id="error-shopping-cart">Winkelmand is leeg</div>:null}
      </div>
  );
};

export default ShoppingCartSummary;